import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    question: {},
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_QUESTION_TO_DUPLICATE:
            return { ...state, question: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/duplicate-question/duplicate-question.reducer.js